'use client';

import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { FC } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './CarSpinAnimation.module.scss';

interface Props {
  totalLoops?: number;
  onComplete?: () => void;
  className?: string;
}

const CarSpinLight = dynamic(() => import('src/general/animations/CarSpinLight').then((mod) => mod.CarSpinLight), {
  ssr: false,
});

const CarSpinAnimation: FC<Props> = ({ className, totalLoops = 1, onComplete }) => (
  <figure className={classNames(styles.root, className)}>
    <figcaption className={styles.caption}>{getMicrocopy(MICROCOPY.PDP_IMAGES_TAKE_IT_FOR_A_SPIN)}</figcaption>
    <CarSpinLight play className={styles.animation} loop={totalLoops} onComplete={onComplete} />
  </figure>
);

export default CarSpinAnimation;
